import React from "react";
import { createPortal } from "react-dom";

const SOURCE_STYLES = {
  global: "text-amber-700 bg-amber-100 border-amber-300",
  environment: "text-green-700 bg-green-100 border-green-300",
  dynamic: "text-purple-700 bg-purple-100 border-purple-300",
  local: "text-blue-700 bg-blue-100 border-blue-300",
  unknown: "text-red-700 bg-red-100 border-red-300",
};

const SOURCE_LABELS = {
  global: "Global",
  environment: "Environment",
  dynamic: "Dynamic",
  local: "Local",
  unknown: "Not Found",
};

const VariableTooltip = ({ isVisible, position, variable, onMouseEnter, onMouseLeave }) => {
  if (!isVisible || !variable) return null;

  const { source, name, raw, resolved } = variable;
  const styleClass = SOURCE_STYLES[source] || SOURCE_STYLES.unknown;

  const tooltip = (
    <div
      className="fixed z-[9999] w-80 p-4 bg-white border border-gray-300 rounded-lg shadow-2xl"
      style={{
        left: Math.max(10, Math.min(position.x - 160, window.innerWidth - 330)),
        top: position.y + 8,
        pointerEvents: "auto",
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="space-y-3 text-sm">
        <div>
          <span className="text-gray-500 font-medium block mb-1 text-xs uppercase tracking-wide">
            Variable
          </span>
          <code className="bg-gray-100 px-2 py-1 rounded text-sm font-mono">{raw}</code>
        </div>

        <div>
          <span className="text-gray-500 font-medium block mb-1 text-xs uppercase tracking-wide">
            Resolved Value
          </span>
          <code className="bg-gray-100 px-2 py-1 rounded text-sm font-mono break-all block">
            {resolved}
          </code>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-gray-500 font-medium text-xs uppercase tracking-wide">Source:</span>
          <span className={`px-2 py-0.5 rounded text-xs font-semibold border ${styleClass}`}>
            {SOURCE_LABELS[source]}
          </span>
        </div>

        {source === "unknown" && (
          <div className="text-red-700 text-xs bg-red-50 p-2 rounded border border-red-200">
            Variable <code className="font-mono">{name}</code> not found. Check spelling or add it
            to an environment.
          </div>
        )}
      </div>
    </div>
  );

  return createPortal(tooltip, document.body);
};

export default VariableTooltip;
